import React, { useEffect, useRef } from 'react';

const VisualizerBackground: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    // Create electric beams
    const createBeams = () => {
      if (!containerRef.current) return;
      
      // Clear existing beams
      while (containerRef.current.firstChild) {
        containerRef.current.removeChild(containerRef.current.firstChild);
      }
      
      // Create new beams
      const beamsCount = window.innerWidth < 768 ? 5 : 10;
      
      for (let i = 0; i < beamsCount; i++) {
        const beam = document.createElement('div');
        beam.className = 'beam';
        
        // Random position
        const leftPosition = Math.random() * 100;
        beam.style.left = `${leftPosition}%`;
        
        // Random animation duration and delay
        const animationDuration = 5 + Math.random() * 10; // 5-15 seconds
        const animationDelay = Math.random() * 5; // 0-5 seconds
        
        beam.style.animation = `beam-move ${animationDuration}s linear ${animationDelay}s infinite`;
        
        containerRef.current.appendChild(beam);
      }
      
      // Create circles
      const circlesCount = window.innerWidth < 768 ? 3 : 6;
      
      for (let i = 0; i < circlesCount; i++) {
        const circle = document.createElement('div');
        const size = 100 + Math.random() * 200; // 100-300px
        
        circle.style.position = 'absolute';
        circle.style.width = `${size}px`;
        circle.style.height = `${size}px`;
        circle.style.borderRadius = '50%';
        circle.style.background = 'radial-gradient(circle at center, rgba(255, 186, 0, 0.2) 0%, transparent 70%)';
        
        // Random position
        circle.style.left = `${Math.random() * 100}%`;
        circle.style.top = `${Math.random() * 100}%`;
        
        // Animation
        const animationDuration = 20 + Math.random() * 30; // 20-50 seconds
        circle.style.animation = `rotate-circle ${animationDuration}s linear infinite`;
        
        containerRef.current.appendChild(circle);
      }
    };
    
    createBeams();
    
    const handleResize = () => {
      createBeams();
    };
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  return (
    <div className="backdrop-visualizer" ref={containerRef}>
      {/* Visual elements will be added dynamically */}
    </div>
  );
};

export default VisualizerBackground;
